import React from 'react';
import { Tooltip } from '@mui/material';
import styled from 'styled-components';
import { Flex, Icon, Typo, theme } from '../../../ui';

const Content = styled.div`
  cursor: pointer;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:240px;
  background-color: ${theme.colors.NEU_50};
  border-radius:14px;
  
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  :hover{
    background-color: ${theme.colors.NEU_200};
  }

  div > i { margin-right: 0.5rem; }
`;

export const ItemTypes = {
  All: 'all',
}

const Folder = ({ data, openFolder }) => {
  return (
    <Tooltip title={data.name} >
      <Content onClick={() => openFolder(data)} >
        <Flex>
          <Icon.Folder size='small' color={theme.colors.NEU_600} />
          <Typo.SmallText>{data.name}</Typo.SmallText>
        </Flex>
      </Content>
    </Tooltip>
  )
}

export default Folder;
